import { useTranslation } from 'react-i18next';

import FormField from '@/components/atoms/FormField';
import TextField from '@/components/atoms/TextField';

import { parseOptionalKg } from '../createHarvestReportForm';

import { LabelWithHelp } from './LabelWithHelp';

import styles from './WeightLimitFields.module.scss';

interface WeightLimitFieldsProps {
    /** Prefix for the inputs' ids. */
    modalId: string;
    weightMin?: number;
    weightMax?: number;
    showError: boolean;
    onWeightMinChange: (kilograms: number | undefined) => void;
    onWeightMaxChange: (kilograms: number | undefined) => void;
}

/** The optional harvest weight range, in kilograms. */
export function WeightLimitFields(props: WeightLimitFieldsProps) {
    const { modalId, weightMin, weightMax, showError, onWeightMinChange, onWeightMaxChange } =
        props;
    const { t } = useTranslation(['harvestReport', 'common']);

    return (
        <>
            <FormField
                label={
                    <LabelWithHelp help={t('harvestReport:common.weightMinTooltip')}>
                        {`${t('harvestReport:common.weightMin')} (${t('harvestReport:common.weightUnitKg')}) (${t('harvestReport:common.optional')})`}
                    </LabelWithHelp>
                }
                htmlFor={`${modalId}-weightMin`}>
                <TextField
                    id={`${modalId}-weightMin`}
                    name="weightMin"
                    type="number"
                    step="0.1"
                    value={weightMin ?? ''}
                    min="0.1"
                    onChange={(ev) => {
                        onWeightMinChange(parseOptionalKg(ev.target.value));
                    }}
                    placeholder=""
                    required={false}
                />
            </FormField>
            <FormField
                label={
                    <LabelWithHelp help={t('harvestReport:common.weightMaxTooltip')}>
                        {`${t('harvestReport:common.weightMax')} (${t('harvestReport:common.weightUnitKg')}) (${t('harvestReport:common.optional')})`}
                    </LabelWithHelp>
                }
                htmlFor={`${modalId}-weightMax`}>
                <TextField
                    id={`${modalId}-weightMax`}
                    name="weightMax"
                    type="number"
                    step="0.1"
                    value={weightMax ?? ''}
                    min="0.1"
                    onChange={(ev) => {
                        onWeightMaxChange(parseOptionalKg(ev.target.value));
                    }}
                    placeholder=""
                    required={false}
                />
            </FormField>
            {/* Present before the message, so a screen reader reads it out as it appears. */}
            <div aria-live="polite">
                {showError && (
                    <p className={styles.error}>{t('harvestReport:common.weightLimitsInvalid')}</p>
                )}
            </div>
        </>
    );
}
